<template>
  <card-list
    data-url="/api/v1/user"
    data-size="10"
    :data-headers="tHeaders"
    edit-route="/master/user/add"
    delete-endpoint="/api/v1/user"
    :deleteReason="true"
    title="User List"
  />
</template>
<script>
import CardList from '../../components/CardList'
export default {
  name: "UserList",
  components: {
    CardList,
  },
  data () {
    return {
      tHeaders: [
        { name: 'Name', align: 'left' },
        { email: 'Email', align: 'left' },
        { phone: 'Phone', align: 'left' },
      ]
    }
  }
}
</script>